import React from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import AuthRedirect from "../../components/authRedirect";



const CabinetHomePage = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Главная')}/>
            <AuthRedirect isCabinet={true}/>
            <div>{t('Главная')}</div>
        </section>
    );
};

export default CabinetHomePage;